import { api } from '../api';
import { AxiosResponse } from "axios";
import { ValidateTokenData } from '../interfaces/Auth';
import { EmptyObjectData, StandardResponse } from '../interfaces/Common';
import { UserData } from '../interfaces/User';

export async function login(credentials: { email: string; password: string }): Promise<StandardResponse<UserData>> {
    const response: AxiosResponse<StandardResponse<UserData>> = await api.post("/auth/signin", credentials, {
        headers: { skipAuth: true }
    });
    return response.data;
}

export async function validate(): Promise<StandardResponse<ValidateTokenData>> {
    const response: AxiosResponse<StandardResponse<ValidateTokenData>> = await api.get("/auth/admin/validate");
    return response.data;
}

export async function forgotPassword(user: { email: string; }): Promise<StandardResponse<EmptyObjectData>> {
    const response: AxiosResponse<StandardResponse<EmptyObjectData>> = await api.post("/auth/password/reset", user, {
        headers: { skipAuth: true, skipGlobalAuthError: true }
    });
    return response.data;
}